// Container
const DefaultContainer = () => import('@/containers/DefaultContainer')

const ManageOperationNotificationList = () => import('@/modules/notifications/views/management/ManageOperationNotificationList')

var routes = [
	{
		path: '/notifications/manage',
        redirect: '/notifications/manage/operations/list',
        name: 'Notifications',
        component: DefaultContainer,
        children: [
            {
                path: 'operations/list',
                name: 'ManageOperationNotificationList',
                component: ManageOperationNotificationList,
                meta: {
                    requiresAuth: true,
                    permission: false,
                },
            },
		]
	}
];

export default routes;
